import { BLOCKS_CLIENT, BLOCKS_CLIENT_WITH_CHAIN, INFO_CLIENT, V3_SUBGRAPH_URLS } from 'config/constants/endpoints'
import { infoClient, infoStableSwapClient } from 'utils/graphql'
import { GraphQLClient } from 'graphql-request'

import { ChainId } from '@pancakeswap/sdk'
import {
  ETH_TOKEN_BLACKLIST,
  PCS_ETH_START,
  PCS_V2_START,
  TOKEN_BLACKLIST,
  BSC_TOKEN_WHITELIST,
  ETH_TOKEN_WHITELIST,
} from 'config/constants/info'

export type MultiChainName = 'MANTLE' | 'MANTLE_TESTNET'

export type MultiChainNameExtend = MultiChainName | 'MANTLE_TESTNET'

export const multiChainName: Record<number | string, MultiChainNameExtend> = {
  [ChainId.MANTLE]: 'MANTLE',
  // [ChainId.ETHEREUM]: 'ETH',
  [ChainId.MANTLE_TESTNET]: 'MANTLE_TESTNET',
}

export const multiChainQueryMainToken = {
  MANTLE: 'ETH',
  MANTLE_TESTNET: 'ETH',
}

export const multiChainBlocksClient = {
  MANTLE: BLOCKS_CLIENT_WITH_CHAIN[ChainId.MANTLE],
  MANTLE_TESTNET: BLOCKS_CLIENT_WITH_CHAIN[ChainId.MANTLE_TESTNET],
}

export const multiChainStartTime = {
  MANTLE: PCS_V2_START,
  MANTLE_TESTNET: PCS_ETH_START,
}

export const multiChainId = {
  MANTLE: ChainId.MANTLE,
  MANTLE_TESTNET: ChainId.MANTLE_TESTNET,
}

export const multiChainPaths = {
  [ChainId.MANTLE]: '',
  [ChainId.MANTLE_TESTNET]: '',
}

export const multiChainQueryClient = {
  MANTLE: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.MANTLE]),
  MANTLE_TESTNET: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.MANTLE_TESTNET]),
}

export const multiChainQueryEndPoint = {
  MANTLE: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.MANTLE]),
  MANTLE_TESTNET: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.MANTLE_TESTNET]),
}

export const multiChainScan = {
  MANTLE: 'MantleScan',
  MANTLE_TESTNET: 'MantleScan',
}

export const multiChainTokenBlackList = {
  MANTLE: TOKEN_BLACKLIST,
  MANTLE_TESTNET: ETH_TOKEN_BLACKLIST,
}

export const multiChainTokenWhiteList = {
  MANTLE: BSC_TOKEN_WHITELIST,
  MANTLE_TESTNET: ETH_TOKEN_WHITELIST,
}

export const getMultiChainQueryEndPointWithStableSwap = (chainName: MultiChainName): GraphQLClient => {
  const isStableSwap = checkIsStableSwap()
  if (isStableSwap) return infoStableSwapClient
  return multiChainQueryClient[chainName]
}

export const v2SubgraphTokenName = {
  '0x738d96caf7096659db4c1afbf1e1bdfd281f388c': 'Ankr Staked MATIC',
}

export const checkIsStableSwap = () => false && window.location.href.includes('stableSwap')
